module.exports = __webpack_public_path__ + "img/icon2.a76863ba.png";